export default __webpack_public_path__ + "static/media/opportunityGraph.cc808bab.svg";